<template>
	<div class="BaseAddEditPS">
		<div class="fields">
			<div v-if="rowData.hasOwnProperty('Calendar Date')" class="field">
				<div class="label">
					<label for="">
						Calendar Date
					</label>
				</div>
				<div class="value">
					<BaseInput
						v-model="rowData['Calendar Date'].value"
						class="baseInput"
						custom-class="p-2.5 text-sm text-amp-input-boxes"
						placeholder="Enter Calendar Date"
					/>
				</div>
				<span v-if="rowData['Calendar Date'].isError">
					<el-tooltip
						class="item"
						effect="dark"
						:content="rowData['Calendar Date'].details.join(',')"
						placement="bottom"
					>
						<i class="el-icon-warning text-base text-red" />
					</el-tooltip>
				</span>
				<span v-if="!rowData['Calendar Date'].isError">
					<i class="el-icon-success text-base text-green" />
				</span>
			</div>
			<div v-if="rowData.hasOwnProperty('Time')" class="field">
				<div class="label">
					<label for="">
						Time
					</label>
				</div>
				<div class="value">
					<BaseInput
						v-model="rowData['Time'].value"
						class="baseInput"
						custom-class="p-2.5 text-sm  text-amp-input-boxes"
						placeholder="Enter Time"
					/>
				</div>
				<span v-if="rowData['Time'].isError">
					<el-tooltip
						class="item"
						effect="dark"
						:content="rowData['Time'].details.join(',')"
						placement="bottom"
					>
						<i class="el-icon-warning text-base text-red" />
					</el-tooltip>
				</span>
				<span v-if="!rowData['Time'].isError">
					<i class="el-icon-success text-base text-green" />
				</span>
			</div>
			<div v-if="rowData.hasOwnProperty('Bill No')" class="field">
				<div class="label">
					<label for="">
						Bill No
					</label>
				</div>
				<div class="value">
					<BaseInput
						v-model="rowData['Bill No'].value"
						class="baseInput"
						custom-class="p-2.5 text-sm  text-amp-input-boxes"
						placeholder="Enter Time"
					/>
				</div>
				<span v-if="rowData['Bill No'].isError">
					<el-tooltip
						class="item"
						effect="dark"
						:content="rowData['Bill No'].details.join(',')"
						placement="bottom"
					>
						<i class="el-icon-warning text-base text-red" />
					</el-tooltip>
				</span>
				<span v-if="!rowData['Bill No'].isError">
					<i class="el-icon-success text-base text-green" />
				</span>
			</div>
			<div v-if="rowData.hasOwnProperty('Order Type')" class="field">
				<div class="label">
					<label for="">
						Order Type
					</label>
				</div>
				<div class="value">
					<BaseInput
						v-model="rowData['Order Type'].value"
						class="baseInput"
						custom-class="p-2.5 text-sm text-amp-input-boxes"
						placeholder="Enter Order Type"
					/>
				</div>
				<span v-if="rowData['Order Type'].isError">
					<el-tooltip
						class="item"
						effect="dark"
						:content="rowData['Order Type'].details.join(',')"
						placement="bottom"
					>
						<i class="el-icon-warning text-base text-red" />
					</el-tooltip>
				</span>
				<span v-if="!rowData['Order Type'].isError">
					<i class="el-icon-success text-base text-green" />
				</span>
			</div>
			<div v-if="rowData.hasOwnProperty('Item Name')" class="field">
				<div class="label">
					<label for="">
						Item Name
					</label>
				</div>
				<div class="value">
					<BaseInput
						v-model="rowData['Item Name'].value"
						class="baseInput"
						custom-class="p-2.5 text-sm text-amp-input-boxes"
						placeholder="Enter Item Name"
					/>
				</div>
				<span v-if="rowData['Item Name'].isError">
					<el-tooltip
						class="item"
						effect="dark"
						:content="rowData['Item Name'].details.join(',')"
						placement="bottom"
					>
						<i class="el-icon-warning text-base text-red" />
					</el-tooltip>
				</span>
				<span v-if="!rowData['Item Name'].isError">
					<i class="el-icon-success text-base text-green" />
				</span>
			</div>

			<div v-if="rowData.hasOwnProperty('Item Code')" class="field">
				<div class="label">
					<label for="">
						Item Code
					</label>
				</div>
				<div class="value">
					<BaseInput
						v-model="rowData['Item Code'].value"
						class="baseInput"
						custom-class="p-2.5 text-sm text-amp-input-boxes"
						placeholder="Enter Item Code"
					/>
				</div>
				<span v-if="rowData['Item Code'].isError">
					<el-tooltip
						class="item"
						effect="dark"
						:content="rowData['Item Code'].details.join(',')"
						placement="bottom"
					>
						<i class="el-icon-warning text-base text-red" />
					</el-tooltip>
				</span>
				<span v-if="!rowData['Item Code'].isError">
					<i class="el-icon-success text-base text-green" />
				</span>
			</div>
			<div v-if="rowData.hasOwnProperty('Total Quantity')" class="field">
				<div class="label">
					<label for="">
						Total Quantity
					</label>
				</div>
				<div class="value">
					<BaseInput
						v-model="rowData['Total Quantity'].value"
						class="baseInput"
						custom-class="p-2.5 text-sm text-amp-input-boxes"
						placeholder="Enter Total Quantity"
					/>
				</div>
				<span v-if="rowData['Total Quantity'].isError">
					<el-tooltip
						class="item"
						effect="dark"
						:content="rowData['Total Quantity'].details.join(',')"
						placement="bottom"
					>
						<i class="el-icon-warning text-base text-red" />
					</el-tooltip>
				</span>
				<span v-if="!rowData['Total Quantity'].isError">
					<i class="el-icon-success text-base text-green" />
				</span>
			</div>
			<div v-if="rowData.hasOwnProperty('Bill Amount')" class="field">
				<div class="label">
					<label for="">
						Bill Amount
					</label>
				</div>
				<div class="value">
					<BaseInput
						v-model="rowData['Bill Amount'].value"
						class="baseInput"
						custom-class="p-2.5 text-sm text-amp-input-boxes"
						placeholder="Enter Bill Amount"
					/>
				</div>
				<span v-if="rowData['Bill Amount'].isError">
					<el-tooltip
						class="item"
						effect="dark"
						:content="rowData['Bill Amount'].details.join(',')"
						placement="bottom"
					>
						<i class="el-icon-warning text-base text-red" />
					</el-tooltip>
				</span>
				<span v-if="!rowData['Bill Amount'].isError">
					<i class="el-icon-success text-base text-green" />
				</span>
			</div>
			<div>
				<BaseButton
					buttonclass="py-2 px-4 text-sm bg-amp w-4 text-white"
					@click="save(rowData)"
				>
					Save
				</BaseButton>
			</div>
		</div>
		<!-- {{ rowData }} -->
	</div>
</template>

<script>
import { PastSales } from "../../../mixins/processCsvFunctions/pastSales.mixin";
import { CommonMixin } from "../../../mixins/common.mixin";
export default {
	name: "BaseAddEditPS",
	mixins: [PastSales, CommonMixin],
	props: {
		rowData: {
			type: Object,
			default: function() {
				return {};
			}
		}
	},
	data() {
		return {
			clonedRowData: this.cloneObject(this.rowData)
		};
	},
	computed: {
		// clonedRowData() {
		// 	return this.cloneObject(this.rowData);
		// }
	},
	methods: {
		save(rowData) {
			// remove the reEdited Time

			this.validateCalenderDate(
				rowData["Calendar Date"].value,
				rowData["Calendar Date"]
			);
			this.validateTime(rowData["Time"].value, rowData["Time"]);

			this.validateBillNo(rowData["Bill No"].value, rowData["Bill No"]);

			this.validateOrderType(
				rowData["Order Type"].value,
				rowData["Order Type"]
			);
			this.validateItemNameAndItemCode(
				rowData["Item Name"].value,
				rowData["Item Code"].value,
				rowData["Item Name"],
				rowData["Item Code"]
			);

			this.validateTotalQuantity(
				rowData["Total Quantity"].value,
				rowData["Total Quantity"]
			);

			this.validateBillAmount(
				rowData["Bill Amount"].value,
				rowData["Bill Amount"]
			);

			if (Object.keys(rowData).every(key => rowData[key].isError === false)) {
				this.$emit("onSave", this.rowData);
			} else {
				this.$notify.error({
					title: "Error",
					message: "There are still some erros",
					type: "error"
				});
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./BaseAddEditPS.scss";
</style>
<style>
.BaseAddEditPS.el-input__inner {
	height: 45px;
	border-radius: 2px;
}
/* .BaseAddEditPS.el-input__inner::placeholder {
	font-size: 0.875rem;
	color: #666;
}
.AppLayout .el-input__inner {
	border: 2px solid #b0b1b3 !important;
}
.AppLayout .el-select .el-input.is-focus .el-input__inner {
	border: 2px solid #bac0fb !important;
} */
</style>
